export const toAssetUrl = (filename: string) => {
	return `${process.env.REACT_APP_ASSETS_HOST}/${filename}`
}

export const sortByDate = (arr: Array<any>, key: string) => {
	// @ts-ignore 
	return arr.sort((a, b) => new Date(a[key]) - new Date(b[key]));
}

export const filterUnique = (arr: Array<any>, key: string) => {
  const seen = new Set();
  return arr.filter(item => {
    const k = item[key];
    return seen.has(k) ? false : seen.add(k);
  });
}